
import { defineComponent, reactive, ref } from 'vue';
import Alert from '@/components/ui-elements/Alert.vue';
import Checkbox from '@/components/ui-elements/form/Checkbox.vue';
import { Form } from '@/components/ui-elements';
import Input from '@/components/ui-elements/form/Input.vue';
import LoaderIcon from '@/components/ui-elements/icons/LoaderIcon.vue';
import { useUserStore } from '@/store';
import { useRouter } from 'vue-router';

export default defineComponent({
	components: {
		Alert,
		Checkbox,
		Form,
		Input,
		LoaderIcon,
	},
	setup(props, { emit }) {
		const { logUserIn } = useUserStore();
		const { push } = useRouter();
		const disableSubmit = ref(false);
		const error = reactive({
			display: false,
			message: '',
		});
		const form = reactive({
			email: {
				rules: ['required', 'email'],
				value: '',
			},
			password: {
				rules: ['required'],
				value: '',
			},
			rememberMe: {
				rules: [],
				value: false,
			},
		});
		const valid = ref(false);

		const login = async () => {
			disableSubmit.value = true;
			const response = await logUserIn({
				username: form.email.value,
				password: form.password.value,
				remember: form.rememberMe.value,
			});

			if (response.success) {
				if (response.data.two_factor) {
					emit('handle-two-factor');
				} else {
					error.display = false;
					error.message = '';
					push({ name: 'home' });
				}
			} else {
				error.display = true;
				error.message = response.error;
				disableSubmit.value = false;
			}
		};

		return { disableSubmit, error, form, login, valid };
	},
});
